var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFileEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3475_77247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3475_77247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.0013 25.6673C6.35964 25.6673 5.81033 25.4388 5.35339 24.9819C4.89644 24.525 4.66797 23.9757 4.66797 23.334V4.66732C4.66797 4.02565 4.89644 3.47635 5.35339 3.0194C5.81033 2.56246 6.35964 2.33398 7.0013 2.33398H16.3346L23.3346 9.33398V23.334C23.3346 23.9757 23.1062 24.525 22.6492 24.9819C22.1923 25.4388 21.643 25.6673 21.0013 25.6673H7.0013ZM15.168 10.5007V4.66732H7.0013V23.334H21.0013V10.5007H15.168Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileEmpty);
export default __webpack_public_path__ + "static/media/icon_file_empty.67b40544c4b5995bc3d49d8432b77974.svg";
export { ForwardRef as ReactComponent };